import { webappDetail } from "@/js/appDetail"

function getSiteMapAddress(list) {
  var result = [];
  if (!list || list.length < 1) return result;
  var datas = Object.assign([], list);
  var addressName = 'Address';
  var detailName = 'Detail';
  datas.forEach(el => {
    var str = {
      ...el,
      content: `<h5 class="map-title">${el.name}</h5>` +
        `<p class="map-info">${addressName}：${el.location}
            <a class="map-link" id="detail${el.id}" href="javascript:;">${detailName}</a>
        </p>`
    }
    result.push(str)
  });
  return result;
}

export function initMarker(data) {
  let latLng = new T.LngLat(parseFloat(data.longitude), parseFloat(data.latitude));

  let iconUrl = require("../assets/images/map_green.png");
  if (!data.online) {
    iconUrl = require("../assets/images/map_offline.png");
  } else if (data.status == 2) {
    iconUrl = require("../assets/images/map_alarm.png");
  }

  var myIcon = new T.Icon({
    iconUrl: iconUrl,
    iconSize: new T.Point(30, 30),
    iconAnchor: new T.Point(15, 15)
  });

  var marker = new T.Marker(latLng, { icon: myIcon });

  return {
    marker: marker,
    point: latLng
  }
}

export function initInfoWindow(data) {
  let str = data.content;
  return new T.InfoWindow(str, { offset: new T.Point(0, -4) });
}

export function initBMap(list, that) {
  if (!list || list.length < 1) return;
  if (typeof T === 'undefined') {
    console.error('T 对象未定义，请检查天地图API是否正确加载');
    return;
  }
  if (!document.getElementById("siteMaps")) {
    console.error("Map container not found");
    return;
  }
  if (that.map) {
    that.map = null;
  }

  that.map = new T.Map("siteMaps");
  that.map.centerAndZoom(new T.LngLat(118.13271, 24.484769), 12);
  that.map.enableScrollWheelZoom();

  var infoWindow = null;
  var ll = getSiteMapAddress(list);

  if (ll.length < 1) return;

  ll.forEach((opt, index) => {
    let iconUrl = require("../assets/images/map_green.png");
    if (!opt.online) {
      iconUrl = require("../assets/images/map_offline.png");
    } else if (opt.status == 2) {
      iconUrl = require("../assets/images/map_alarm.png");
    }

    var myIcon = new T.Icon({
      iconUrl: iconUrl,
      iconSize: new T.Point(30, 30),
      iconAnchor: new T.Point(15, 15)
    });

    var marker = new T.Marker(new T.LngLat(opt.longitude, opt.latitude), { icon: myIcon });

    that.map.addOverLay(marker);
    marker.data = opt;

    marker.addEventListener("click", function(e) {
      if (infoWindow) {
        that.map.closeInfoWindow();
      }

      var targetData = this.data;
      let content = `<h5 class="map-title">${targetData.name}</h5>` +
        `<p class="map-info">Address：${targetData.location}
            <a class="map-link" id="detail${targetData.id}" href="javascript:;">Detail</a>
        </p>`;

      infoWindow = new T.InfoWindow(content, { offset: new T.Point(0, -4) });

      that.map.openInfoWindow(infoWindow, new T.LngLat(targetData.longitude, targetData.latitude));

      setTimeout(() => {
        var detailBtn = document.getElementById("detail" + targetData.id);
        if (detailBtn) {
          detailBtn.onclick = function() {
            webappDetail(targetData.id);
          }
        }
      }, 100);
    });
  });

  if (ll.length > 0) {
    var bounds = ll.reduce(function(acc, opt) {
      var lat = parseFloat(opt.latitude);
      var lng = parseFloat(opt.longitude);
      return {
        minLat: Math.min(acc.minLat, lat),
        maxLat: Math.max(acc.maxLat, lat),
        minLng: Math.min(acc.minLng, lng),
        maxLng: Math.max(acc.maxLng, lng)
      };
    }, { minLat: Infinity, maxLat: -Infinity, minLng: Infinity, maxLng: -Infinity });

    var latLngBounds = new T.LngLatBounds(
      new T.LngLat(bounds.minLng, bounds.minLat),
      new T.LngLat(bounds.maxLng, bounds.maxLat)
    );

    that.map.fitBounds(latLngBounds);
  }
}

export function initGoogleMap(list, that) {
  if (!list || list.length < 1) return;
  var infoWindow = new google.maps.InfoWindow();
  if (that.longitude && that.latitude) {
    that.googleMap = new google.maps.Map(
      document.getElementById("siteMaps"), {
        center: {
          lat: that.latitude,
          lng: that.longitude
        },
        zoom: 10
      }
    );
    var newPos = {
      lat: that.latitude,
      lng: that.longitude
    };
    infoWindow.setPosition(newPos);
    infoWindow.setContent(newPos.lat + ",</br>" + newPos.lng);
    infoWindow.open(that.googleMap);
    that.latitude = newPos.lat;
    that.longitude = newPos.lng;
  } else {
    that.googleMap = new google.maps.Map(
      document.getElementById("siteMaps"), {
        center: {
          lat: 24.485821,
          lng: 118.095915
        },
        zoom: 10
      }
    );
    var infowindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    var markerList = getSiteMapAddress(list);
    if(!markerList||markerList.length<1)return;
    for(var i=0;i<markerList.length;i++){
      bounds.extend(new google.maps.LatLng(markerList[i].latitude,markerList[i].longitude))
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(markerList[i].latitude,markerList[i].longitude),
        map: that.googleMap,
      });
      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(markerList[i].content);
          infowindow.open(that.googleMap, marker);
        }
      })(marker, i));
      google.maps.event.addListener(infowindow, "domready", (function (infowindow,i) {
        return function(){
          if(document.getElementById("detail" + markerList[i].id)){
            document.getElementById("detail" + markerList[i].id).onclick = function (e) {
              var id = this.getAttribute('data-id');
              webappDetail(id);
            }
          }
        }
      })(infowindow,i));
      marker.setMap(that.googleMap);
    }
    that.googleMap.fitBounds(bounds);
  }
}
